/**
 * Description: Creates a browser host object so the engine never touches global window/document directly.
 * Usage: Pass to NanoNomad({ host }); in SSR contexts omit start() until a host exists on the client.
 */
export function createBrowserHost(globalObj) {
  const g = globalObj || (typeof globalThis !== 'undefined' ? globalThis : {});
  const win = g.window || (typeof window !== 'undefined' ? window : null);
  if (!win || !win.document) {
    throw new Error('NanoNomad: createBrowserHost requires a Window with document');
  }
  return {
    window: win,
    document: win.document,
  };
}
